<template>
    <transition name="confirm">
        <div v-if="show">
            <div class="dialogbox-mask"></div>
            <div class="dialogbox" v-bind:class="[show?'fade-in':'fade-out']">
                <div class="dialogboxmain">
                    <div class="dialogbox-confirm-title">
                        <span class="confirm-tit">{{title}}</span>
                        <div class="confirm-close" @click="close">×</div>
                    </div>
                    <div class="dialogbox-confirm-content" v-html="content"></div>
                    <div class="dialogbox-confirm-footer">
                        <div class="confirm-btn-groups">
                            <div class="confirm-btn confirm-delete" @click="cancel">{{canceltxt}}</div>
                            <div class="confirm-btn confirm-okok" :class="{'confirm-okok-red':isredbtn}" @click="success">{{confirmtxt}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        data(){
            return {
                show:false,
                title:'',
                content:'',
                style:{},
                canceltxt:'取消',
                confirmtxt:'确认',
                isredbtn:false

            }
        },
        methods:{
            close(){
              this.show = false;
            },
            success(){
//                this.show = false;
            },
            cancel(){
//                this.show = false;
            }

        }
    }

</script>
<style scoped>
    @import "./tpl.css";
    .confirm-enter {
        opacity: 0;
    }
    .confirm-enter-active, .confirm-leave-active {
        transition: all .12s;

    }
    .confirm-leave-active {
        opacity: 0;
    }

    @keyframes fade-in{
        0% {
            opacity: 0;
            transform:scale(0.8);
        }
        100% {
            opacity: 1;
            transform:scale(1);
        }
    }
    @keyframes fade-out{
        0% {
            opacity: 1;
            transform:scale(1);
        }
        100% {
            opacity: 0;
            transform:scale(0.7);
        }
    }
    .fade-in{
        animation-name: fade-in;
        animation-duration:0.3s;
        animation-fill-mode: both;
    }
    .fade-out{
        animation-name: fade-out;
        animation-duration:0.3s;
        animation-fill-mode: both;
    }
</style>


// WEBPACK FOOTER //
// tpl.vue?75222599